import { useEffect } from 'react'
import { saveUtmToCookie } from 'src/utils/helpers/GeneralHelpers'

const UtmTracker = ({ children }) => {
  useEffect(() => {
    saveUtmToCookie()
  }, [])
  return children
}

export default UtmTracker
